export default {
	popup:                false,
	popupTitle:           null,
	timer:                null,
	load:                 false,
	id:                   false,
	deal:                 false,
	tenants:         	    [],
	tenantsErrors:        [],
	maintenance:          [],
	tempMaintenance:      [],
	amortizationAnnually: [],
	amortizationMonthly:  [],
};
